import Logo from '../../UIElements/Logo/Logo';

import instagram from '../../../assets/images/instagram.webp';
import email from '../../../assets/images/email.webp';
import location from '../../../assets/images/location.webp';

import styles from './Footer.module.css';

const Footer = () => {
	const year = new Date().getFullYear();

	const instagramStyles = {
		backgroundImage: `url(${instagram})`,
		backgroundSize: 'cover',
  	backgroundRepeat: 'no-repeat',
  	height: '24px',
  	width: '24px'  
	}

	const emailStyles = {
		backgroundImage: `url(${email})`,
		backgroundSize: 'cover',
  	backgroundRepeat: 'no-repeat',
  	height: '20px',
  	width: '25px'  
	}

	const locationStyles = {
		backgroundImage: `url(${location})`,
		backgroundSize: 'cover',
  	backgroundRepeat: 'no-repeat',
  	height: '24px',
  	width: '17px'  
	}

	return (
		<div className={styles.Footer}>
			<div className='container'>
				<div className='row'>
					<div className='col-12 d-flex justify-content-between align-items-center'>
						<div className="d-flex align-items-center">
							<Logo small/>
							<p className='m-0 ms-3 small d-none d-sm-block'> &copy; <span>{year}</span> </p>
						</div>
						<div>
							<div className="d-flex align-items-center">
								<a href="https://www.instagram.com/trueoliveco/" target="_blank" className="mx-2">
									<div style={instagramStyles}></div>
								</a>
								<a href="mailto:contact@trueolive.co" target="_blank">
									<div style={emailStyles}></div>
								</a>
								<a href="https://maps.app.goo.gl/9VpyUhgBS7dVe1dy9" target="_blank" className="mx-2">
									<div style={locationStyles}></div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Footer;